import React, { createContext, useContext } from 'react';
import { useSpotifyAuth } from '../hooks/useSpotifyAuth';
import { useYouTubeAuth } from '../hooks/useYouTubeAuth';

const GlobalContext = createContext(null);

export const GlobalAuthProvider = ({ children }) => {
  const spotifyAuth = useSpotifyAuth();
  const youtubeAuth = useYouTubeAuth();

  const value = {
    spotify: spotifyAuth,
    youtube: youtubeAuth,
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalAuth = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalAuth must be used within GlobalAuthProvider');
  }
  return context;
};
